import { useEffect, useRef } from "react";

import { debounce } from "@shared/utils/debounce/debounce";

const useDebounce = <T extends (...args: any[]) => any>(fn: T, delay: number) => {
  const ref = useRef(debounce(fn, delay));

  useEffect(() => {
    return () => {
      ref.current.cancel();
    };
  }, []);

  return ref.current;
};

export { useDebounce };
